module.exports = __webpack_public_path__ + "024d089ea89cf5c1a84e878d0f967b41.pdf";